import { memo } from 'react'
import { WalletGrid, WalletSelection, WalletType } from './styles'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { useConnect } from '@starknet-react/core'
import StarknetWalletOption from './StarknetWalletOption'

export const StarknetWalletSelection = memo(() => {
  const { connectors } = useConnect()

  return (
    <WalletSelection>
      <WalletType>
        <AccountBalanceWalletIcon sx={{ fontSize: '20px' }} />
        Starknet Wallets
      </WalletType>

      <WalletGrid>
        {connectors.map((connector) => (
          <StarknetWalletOption key={connector.id} connector={connector} />
        ))}
      </WalletGrid>
    </WalletSelection>
  )
})
